var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7022648 14.85c-2.12629632 0-3.85000004-1.7237037-3.85000004-3.85 0-2.12629629 1.72370372-3.85 3.85000004-3.85 2.1262963 0 3.85 1.72370371 3.85 3.85 0 2.1262963-1.7237037 3.85-3.85 3.85m8.173-2.783c.044-.352.077-.704.077-1.067s-.033-.726-.077-1.1l2.321-1.793c.209-.165.264-.462.132-.704l-2.2-3.806c-.132-.242-.429-.341-.671-.242l-2.739 1.1c-.572-.429-1.166-.803-1.859-1.078l-.407-2.915c-.044-.264-.275-.462-.55-.462H8.50226476c-.275 0-.506.198-.55.462l-.407 2.915c-.693.275-1.287.649-1.859 1.078l-2.739-1.1c-.242-.099-.539 0-.671.242l-2.2 3.806c-.143.242-.077.539.132.704l2.321 1.793c-.044.374-.077.737-.077 1.1 0 .363.033.715.077 1.067l-2.321 1.826c-.209.165-.275.462-.132.704l2.2 3.806c.132.242.429.33.671.242l2.739-1.111c.572.44 1.166.814 1.859 1.089l.407 2.915c.044.264.275.462.55.462h4.40000004c.275 0 .506-.198.55-.462l.407-2.915c.693-.286 1.287-.649 1.859-1.089l2.739 1.111c.242.088.539 0 .671-.242l2.2-3.806c.132-.242.077-.539-.132-.704l-2.321-1.826z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4e71b3a0b5c9c29d66eb5d1dece207e7.svg";
export { ForwardRef as ReactComponent };